import SelfTailorResumeModal from './SelfTailorResumeModal'
export default SelfTailorResumeModal
